const mediaQuery = {
  mobile: "480px",
  tablet: "850px",
  laptop: "1024px",
  desktop: "1300px",
  max: "1440px",
};

export default mediaQuery;
